import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';

export default function CancelButton() {

  let navigate = useNavigate();
  const routeChange = () =>{
    let path = `/web/login`;
    navigate(path, { replace: true });
  }

  return (
    <Button className="login primary text" size="small" onClick={routeChange}>Cancelar</Button>
  );
}